/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const user = {
  anonymousConsents: {
    preferences: 'Preferências de consentimento',
    dialog: {
      title: 'Gerenciamento de consentimento',
      legalDescription:
        "We use cookies/browser's storage to personalize the content and improve user experience. We also might share the data about your site usage with our social media. For more, please review our privacy policy.",
      selectAll: 'Selecionar tudo',
      clearAll: 'Apagar tudo',
    },
    banner: {
      title: 'Este site usa cookies',
      description:
        "We use cookies/browser's storage to personalize the content and improve user experience.",
      allowAll: 'Permitir tudo',
      viewDetails: 'Ver detalhes',
    },
  },
  checkoutLogin: {
    emailAddress: {
      label: 'Endereço eletrônico',
      placeholder: 'Digite o e-mail',
    },
    confirmEmail: {
      label: 'Confirmar e-mail',
      placeholder: 'Confirmar e-mail',
    },
    continue: 'Continuar',
    emailIsRequired: 'Formato de e-mail inválido',
    emailsMustMatch: 'O e-mail não corresponde',
  },
  authMessages: {
    signedOutSuccessfully: 'Você foi desconectado com sucesso.',
  },
};
